export class BuildingReq {
	address: BuildingAddress
	cluster_appartenenza: string
	coordinate: { latitudine: number; longitudine: number }
	id_building: string
	identificativo_pop: string
	stato_building: number
}

export class PopReq {
	address: PopAddress
	cluster_appartenenza: string
	coordinate: { latitudine: number; longitudine: number }
	identificativo_pop: string
	alias_pop: string
	nome: string
}

export interface BuildingAddress {
	civico: number
	comune: string
	indirizzo: string
	particella_toponomastica: string
	provincia: string
	regione: string
}

export interface PopAddress {
	civico: number
	comune: string
	indirizzo: string
}
